import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';


@Injectable()

export class JwtInterceptor implements HttpInterceptor {
    static parameters = [AuthService];
    constructor(
        private authService: AuthService
    ){}

    intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>>{
        let currentUser = this.authService.currentUserValue;
        console.log('jwt interceptor currentUser ', currentUser);
        if (currentUser && currentUser.token){
            request = request.clone({
                setHeaders: {
                    Authorization : 'Bearer ' + currentUser.token
                }
            })
        }

        return next.handle(request);
    }
}